import React from 'react'
import styled, { css } from 'styled-components'
import { string, func, bool } from 'prop-types'
import { stripUnit } from 'polished'

import { fontWeights, fontSizes } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { borderRadius, inputHeight, inputHeightMobile, animationTime, animationCurve } from 'styles/global'
import { borderColor, black, greyLight } from 'styles/colors'
import { media } from 'styles/media'

const Container = styled.button`
  display: inline-flex;
  border: 1px solid ${borderColor};
  color: ${greyLight};
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: ${borderRadius};
  justify-content: center;
  height: ${inputHeightMobile};
  padding: 0 ${spacing.large};
  cursor: pointer;
  text-align: center;
  transition: all ${animationTime} ${animationCurve};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.small};

  ${media.medium`
    height: ${inputHeight};
  `};

  ${props =>
    props.active &&
    css`
      border-color: ${black};
      color: ${black};
    `};

  & + & {
    margin-left: ${stripUnit(spacing.small) * 1.5 + 'px'};
  }
`

const Choice = ({ label, active, onClick }) => {
  return (
    <Container active={active} onClick={onClick}>
      {label}
    </Container>
  )
}

Choice.propTypes = {
  label: string.isRequired,
  active: bool,
  onClick: func.isRequired
}

export default Choice
